
<template>
   <div>
      <v-container>
         <v-layout row wrap>

            <v-flex sd-8 xs12>
               <v-card class="mycard">
                  <v-card-text>
                     <h1>Nutri-Kiosk</h1>
                     <p>Pour comprendre la nutrition en s'amusant</p>
                  </v-card-text>
               </v-card>
            </v-flex>

            <v-flex sd-4 xs12>
               <v-card class="mycard">
                  <v-card-text>
                     <h1>Nutri-Kiosk</h1>
                     <p>Pour comprendre la nutrition en s'amusant</p>
                  </v-card-text>
               </v-card>
            </v-flex>
         
         </v-layout>
      </v-container>
   </div>
</template>


<script>
   import moment from 'moment'

   export default {

      mounted () {
         // fetch questions; reactivity will update question list
         this.$store.dispatch('nutrikiosk/GET_QCU_QUESTIONS')
      },

      data: () => ({
      }),

      methods: {
      },
      
      computed: {
         questions() {
            return this.$store.getters['nutrikiosk/qcuQuestions']
         },
      },
   }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// NutriKiosk.vue?8a7d8940